import { useCallback, useMemo, useRef } from 'react';
import { getLabelFromOptions, getOptionValues } from '../utils';
export const useAutocompleteWithValueData = ({ handleChange, onChange, freeSolo, createOptions, optionsFilter, options, value, valuePropName, labelPropName })=>{
    const handleValueChange = useCallback((e, val, reason)=>{
        const value = freeSolo ? val : getOptionValues(val);
        handleChange(e, value, reason === 'reset');
        onChange?.(e, value);
    }, [
        handleChange,
        onChange,
        freeSolo
    ]);
    const computedOptions = useMemo(()=>createOptions({
            freeSolo,
            optionsFilter,
            valuePropName,
            labelPropName,
            options
        }), [
        createOptions,
        freeSolo,
        optionsFilter,
        valuePropName,
        labelPropName,
        options
    ]);
    const previousValue = useRef(null);
    // mui autocomplete has useEffect dependency on value
    // to prevent issue with reset of autocomplete keep same reference to value if not changed
    // it is because of computedOptions can change in case of live BE filtering.
    const valueLabel = useMemo(()=>{
        const newValue = freeSolo ? value ?? null : getLabelFromOptions(value, computedOptions);
        if (JSON.stringify(newValue) !== JSON.stringify(previousValue.current)) {
            previousValue.current = newValue;
        }
        return previousValue.current;
    }, [
        freeSolo,
        value,
        computedOptions
    ]);
    return {
        handleValueChange,
        computedOptions,
        valueLabel
    };
};
